import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProofOnAppPage } from './proof-on-app';
import {PipesModule} from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    ProofOnAppPage,
  ],
    imports: [
        IonicPageModule.forChild(ProofOnAppPage),
        PipesModule,
    ],
  exports: [
    ProofOnAppPage
  ]
})
export class ProofOnAppPageModule { }



// WEBPACK FOOTER //
// ./src/pages/proof-on-app/proof-on-app.module.ts